import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Accordion from 'aquilla/core/molecules/Accordion';
import Typography from 'aquilla/core/atoms/Typography';
import useCertificationCourseData from './useCertificationCourseData';

const Wrapper = styled.div`
  display: grid;
  gap: ${Spacings.SPACING_6B};
  width: 100%;
`;

const StyledAccordion = styled(Accordion)`
  border: ${Spacings.SPACING_1} solid var(--color-i-gray-14);
`;

const Title = styled(Typography)``;
const FAQsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const Header = styled(Typography)`
  white-space: break-spaces;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    line-height: ${Spacings.SPACING_18};
  }
`;

const CertificationCoursesFAQS = ({ goalUID }) => {
  const { sections } = useCertificationCourseData(goalUID);
  const programFaQs = sections?.programFaQs ?? {};
  return (
    <Wrapper>
      <Title variant="h3">{programFaQs?.faqTitle}</Title>
      <FAQsWrapper>
        {programFaQs?.faqs?.map((faq) => {
          return (
            <StyledAccordion
              key={faq.uid}
              title={<Header variant="h5">{faq.question}</Header>}
            >
              {faq.answer}
            </StyledAccordion>
          );
        })}
      </FAQsWrapper>
    </Wrapper>
  );
};

export default CertificationCoursesFAQS;
